import {
    TextHelper,
    SmallTextHelper,
    UrlHelper,
    ArrayHelper
} from '../../PrismicHelpers';

export const textBlockSlice = (data) => {
    // Always take the slice_type and return it with data, helper will know what to display/render
    const dataType = data.slice_type;
    // Non repetable data inside slice
    const sliceFixedData = data.primary;
    // Repetable data (example: buttons)
    //const sliceRepetableData = data.items;

    // Data to send to the array of slices (always type and data if needed)
    let dataToSend = {
        type: dataType,
        title: TextHelper(sliceFixedData.title),
        text_align: SmallTextHelper(sliceFixedData.text_align),
        margins: SmallTextHelper(sliceFixedData.margins),
        description: ArrayHelper(sliceFixedData.description),
        button_title: TextHelper(sliceFixedData.button_title),
        button_url: UrlHelper(sliceFixedData.button_url),
    };
    return dataToSend;
}



// WEBPACK FOOTER //
// src/client/helpers/prismicHelpers/prismic-slice-helpers/single-slice-helpers/textBlockSlice.js